import CardBody from './CardComponents/CardBody/CardBody';
import CardFooter from './CardComponents/CardFooter/CardFooter';
import CardHeader from './CardComponents/CardHeader/CardHeader';
import './IntroductionCard.css';
import './Card.css';

function IntroductionCard(props:{
    changeState: () => void,
}){
    return(
        <div className='card df fdc aic jcsb'>
            <CardHeader title='GSPEN'/>
            <CardBody 
                heading='გამოთვალე შენი კალორიული გეგმა'
                paragraph='კალორიული გეგმა გვიჩვენებს თუ რა ტიპის და რა რაოდენობის საკვები უნდა მივირთვათ დღის განმავლობაში, ჩვენს ფიზიკურ მონაცემებზე დაყრდნობით. გეგმა მოიცავს სხვადასხვა ტიპის საკვების ფართო სპექტრს.'
            />
            <CardFooter 
                button='start'
                buttonTitle='დაწყება'
                note='*დამატებითი ინფორმაციისთვის მიმართეთ კვალიფიციურ პერსონალს'
                changeState={props.changeState}
            />
        </div>
    )
}

export default IntroductionCard;